import { useMutation } from "@tanstack/react-query";
import axios from "axios"

const useSignup = () => {
    return useMutation(async (payload: { name: string, email: string, mobile?: string, referral_code?: string }) => {
        const res = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/method/frappe.core.doctype.user.user.sign_up`, {
            full_name: payload.name,
            email: payload.email,
            mobile_no: payload.mobile,
            redirect_to: "/",
            referral_code: payload.referral_code,
        }, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })
        return res
    })
}

export default useSignup;